import { onMounted, watch } from 'vue';
import { useUiStore } from '@/stores/uiStore';

export function useDarkMode() {
  const { isDark, setDarkMode, toggleDarkMode } = useUiStore();

  // Al montar, leemos del storage o preferencia del sistema
  onMounted(() => {
    const storedTheme = localStorage.getItem('frontline-theme');
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;

    setDarkMode(storedTheme === 'dark' || (!storedTheme && prefersDark));
  });

  // Observamos cambios para guardar y aplicar (el estado vive en uiStore, A2)
  watch(isDark, (val) => {
    if (val) {
      document.documentElement.classList.add('dark');
      localStorage.setItem('frontline-theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('frontline-theme', 'light');
    }
  });

  return { isDark, toggleDarkMode };
}